import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';

import FailsafeImg from 'components/global/application/FailsafeImg';
import { imageUrlAppendStyle } from 'contexts/link_util';
import { renderPrice } from 'contexts/prices';
import { InventoryInstrument } from 'types/drupal/InstrumentNode';

import { instrumentImageAltRef, instrumentImageUrlRef } from 'contexts/instrument';

import './InventoryItem.sass';

interface Props {
    item: InventoryInstrument;
    isMobile: boolean;
}

const InventoryItem: React.StatelessComponent<Props> = ({ item, isMobile }) => {
    const imgSrc = instrumentImageUrlRef(item, 'large');
    const imgAlt = instrumentImageAltRef(item);
    return (
        <div className={`Inventory-item${isMobile ? '-mobile' : ''}`}>
            <Link className="inventory-item-link" to={`/${item.alias}`}>
                <FailsafeImg className="responsive-img Image" src={imgSrc} alt={imgAlt} />
                <span className="Name">{_.get(item, 'field_manufacturer.manufacturer.name')} {_.get(item, 'field_instr_model.value')} {_.get(item, 'field_instr_year.value')}</span>
                <span className="Serial">{item.field_gruhn_category_id.value}</span>
                <span className="Price">{renderPrice(item)}</span>
            </Link>
        </div>
    );
};

export default InventoryItem;



// WEBPACK FOOTER //
// ./src/components/pages/inventory/InventoryItem.tsx